'use client';

import type { PortalTarget } from '../../../store/projectStore';
import { TargetScopePicker } from '../../project/TargetScopePicker';

export function ApplicationSelectorWithoutTitle({
  disabled,
  size = 'sm',
  onApplicationSelected,
}: {
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  onApplicationSelected?: (target: PortalTarget) => void;
}) {
  return (
    <TargetScopePicker
      disabled={disabled}
      size={size}
      layout="horizontal"
      targetInput="combobox"
      onTargetSelected={onApplicationSelected}
    />
  );
}
